export default "__VITE_ASSET__CkrEO3oE__"